import { RootState } from '@/stores/store';

export const getEditFormState = (state: RootState) => state.editForm;
